(function (angular) {
    'use strict';

    angular.module("dentist").directive('navigationSelectWrapper', function() {
    return {
        link: function($scope, element, attrs) {
            // Trigger when number of children changes,
            // including by directives like ng-repeat
            // optimization: this could also be done with event broadcasting and catching (https://stackoverflow.com/questions/16935766/run-jquery-code-after-angularjs-completes-rendering-html)
            var watch = $scope.$watch(function() {
                return element.children().length;
            }, function() {
                // Wait for templates to render
                $scope.$evalAsync(function() {
                    // Finally, directives are evaluated
                    // and templates are renderer here
//                    var children = element.children();
//                    console.log(children);
                    initNavigationSelect();
                    initCustomForms();
                });
            });
        },
    };
});

})(window.angular);
